import EfSpec from '@elem/ui/ef-spec';
import EcoSection from 'eco-design/base/eco-section';
import EcoTab, { EcoTabItemProps } from 'eco-design/elements/eco-tab';
import styles from './index.module.scss';
import { useLang } from '@/i18n';
import { Swiper, SwiperSlide } from 'swiper/react';
import EcoImg from 'eco-design/base/eco-img';
import { useMemo, useState } from 'react';
import EcoIconArrow from 'eco-design-micro/icons/eco-icon-arrow';
import { Navigation, Pagination } from 'swiper';

export default function TheComp() {
    const { t } = useLang('delta3series');

    const list = [
        {
            tabLabel: t('D_item1_tab'),
            tabValue: t('D_item1_tab'),
            title: t('D_item1_title'),
            desc: t('D_item1_desc'),
            pc: 'https://websiteoss.ecoflow.com/upload/image/1751002143987/1.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1751002143241/1-h5.jpg',
        },
        {
            tabLabel: t('D_item2_tab'),
            tabValue: t('D_item2_tab'),
            title: t('D_item2_title'),
            desc: t('D_item2_desc'),
            pc: 'https://websiteoss.ecoflow.com/upload/image/1751002143445/2.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1751002144541/2-h5.jpg',
        },
        {
            tabLabel: t('D_item3_tab'),
            tabValue: t('D_item3_tab'),
            title: t('D_item3_title'),
            desc: t('D_item3_desc'),
            pc: 'https://websiteoss.ecoflow.com/upload/image/1751002144363/3.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1751002143654/3-h5.jpg',
        },
        {
            tabLabel: t('D_item4_tab'),
            tabValue: t('D_item4_tab'),
            title: t('D_item4_title'),
            desc: t('D_item4_desc'),
            pc: 'https://websiteoss.ecoflow.com/upload/image/1751002143834/4.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1751002144168/4-h5.jpg',
        },
    ];

    const [active, setActive] = useState(0);
    const item = useMemo(() => list[active], [active]);

    const [swiper, setSwiper] = useState<any>(null);

    return (
        <div className={styles.TheComp}>
            <EfSpec className="spec-x" />
            <EcoSection className="title" title={t('D_title')} desc={t('D_desc')} />
            <Swiper
                modules={[Navigation, Pagination]}
                pagination
                navigation={true}
                onSwiper={(swiper) => setSwiper(swiper)}
                onSlideChange={(swiper) => setActive(swiper.activeIndex)}
            >
                {list.map((i) => (
                    <SwiperSlide key={i.tabValue}>
                        <EcoImg pc={i.pc} h5={i.h5} />
                    </SwiperSlide>
                ))}
            </Swiper>
            <EcoTab
                items={list}
                activeIndex={active}
                onChange={(e, idx) => {
                    setActive(idx);
                    swiper.slideTo(idx);
                }}
            />
            <EcoSection className="footer-info" title={item.title} desc={item.desc} />
            <EfSpec className="spec-x" />
        </div>
    );
}
